import { Box, List, ListItem, Typography, useTheme } from "@mui/material"
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { Link } from "react-router-dom";
import { mastImages } from "./data/mastData";
import { Fade } from 'react-slideshow-image'
import 'react-slideshow-image/dist/styles.css';
const Mast: React.FC = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        marginTop: "64px",
        display: "flex",
        justifyContent: "center"
      }}
    >
      <Box sx={{ width: "256px" }}>
        <Fade duration={30000} transitionDuration={500} arrows={false} pauseOnHover={false}>
          {mastImages.map((image) => (
            <img src={image} key={image} alt="profile" style={{
              maxHeight: "256px",
              borderRadius: "400px",
              width: "100%"
            }} 
            />
            )
          )}
        </Fade>
      </Box>
      <Box sx={{
        display: 'grid',
        gridTemplateColumns: "auto",
      }}>
        <Typography variant="h1" color="primary" textAlign='center' sx={{ padding: '20px' }}>Andrew Daly</Typography>
        <Typography variant="h2" color="primary" textAlign='center' sx={{ padding: '20px' }}>Software Developer</Typography>
        <List
          sx={{
            display: "flex",
            justifyContent: 'space-evenly',
            background: theme.palette.background.default
          }}

        >
          <ListItem sx={{
            display: 'flex',
            justifyContent: 'right'
          }}>
            <Link
              target="_blank"
              rel="noopener noreferrer"
              to="https://www.linkedin.com/in/drew-daly-uiuc2025/"
            >
              <FaLinkedin size={40} fill={theme.palette.primary.main} />
            </Link>
          </ListItem>
          <ListItem
            sx={{
              display: 'flex',
              justifyContent: 'left'
            }}>
            <Link
              target="_blank"
              rel="noopener noreferrer"
              to="https://github.com/drewDaly"
            >
              <FaGithub size={40} fill={theme.palette.primary.main} />
            </Link>
          </ListItem>
        </List>
      </Box>
    </Box>
  )
}
export default Mast;